import DosRejectedComment from './model';

const create = (data) => new DosRejectedComment(data);

export default create;



// WEBPACK FOOTER //
// ./data/ProgressReports/StudentReportSummaries/DosRejectedComment/create.js